import { render, staticRenderFns } from "./InfoContainer.vue?vue&type=template&id=2ef01b14"
import script from "./InfoContainer.vue?vue&type=script&lang=js"
export * from "./InfoContainer.vue?vue&type=script&lang=js"
import style0 from "./InfoContainer.vue?vue&type=style&index=0&id=2ef01b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports